import { render, staticRenderFns } from "./CompTableVariable.vue?vue&type=template&id=8756b456&scoped=true"
import script from "./CompTableVariable.vue?vue&type=script&lang=js"
export * from "./CompTableVariable.vue?vue&type=script&lang=js"
import style0 from "./CompTableVariable.vue?vue&type=style&index=0&id=8756b456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8756b456",
  null
  
)

export default component.exports